export default function EcomRetail() {
  return (
    <>
      <section className="ecom-retail-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h2 className="heading center-heading"><span className="gradiant-color">Ecommerce Development Solutions </span>
              for Both Online and Traditional Retailers</h2>
              <p className="sub-heading">Regardless of your retail format, our team possesses the expertise and experience to provide an effective e-commerce solution that captivates your target audience. We focus on customized functionality, elegant design, and a user-centric approach.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
